<!--
 * @FileDescription: 模板（注释描述）
 * @Author: xy（作者）
 * @Date: 2020-04-13（时间）
 * @LastEditors: xy（最后更新人）
 * @LastEditTime: 2020-04-13（最后更新时间）
 -->
<template>
  <div class="page-container">
      <div class="page-container-height">

      </div>
  </div>
</template>
<script>
import {getPageAccount} from "@/utils/api";
import {mixins} from "@/mixins/mixins";
export default {
    mixins:[mixins],
    data(){
        return{

        }
    },
    watch: {

    },
    mounted () {

    },
    created () {

    },
    components: {


    },
    methods: {
        /**
        * @description: 此为方法注释（方法描述）
        * @param {参数类型} 参数名称
        * @return void
        */

    },

}
</script>
<style scoped lang="scss">

</style>
